/**
 * Spinner — 読み込み・送信中のインジケータ (#15)
 * prefers-reduced-motion 時は animate-spin が無効化されても形状で「処理中」が伝わる。
 */

interface SpinnerProps {
  size?: number
  className?: string
  label?: string
}

export default function Spinner({ size = 18, className = '', label }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={`inline-flex items-center gap-2 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className="animate-spin"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" opacity="0.2" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {label && <span>{label}</span>}
    </span>
  )
}

/** ページ全体のローディング（中央寄せ） */
export function PageLoader({ label = '読み込み中...' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-text-muted">
      <Spinner size={28} />
      <span className="text-sm">{label}</span>
    </div>
  )
}
